import { styled } from '@mui/material/styles';

export const StyledMain = styled('main')(() => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',

}));
